import { Button } from "antd";

import {
  useMessageContext,
  useModalContext,
  useTasksContext,
} from "../../../providers";

import { tasksFetcher } from "../../../services/api";

import ModalContainer from "../ModalContainer";

import styles from "./DeleteTask.module.css";

const DeleteTaskModal = () => {
  const { modalOpen, closeModal, taskSelected } = useModalContext();

  const { sendMessage } = useMessageContext();
  const { updateTask } = useTasksContext();

  const modalMessage = `En eliminar la tasca "${taskSelected?.name}", s'esborraran de manera definitiva totes les seves dades. Aquesta acció és irreversible.`;

  return (
    <ModalContainer
      centered={false}
      onCancel={closeModal}
      open={modalOpen === "deleteTask"}
      width={550}
    >
      <h3 className="xl">Confirmació d'eliminació de tasca</h3>
      <p>{modalMessage}</p>
      <footer className={styles.footer}>
        <Button onClick={closeModal} type="default">
          Cancel·lar
        </Button>
        <Button
          onClick={async () => {
            if (!taskSelected) return;
            try {
              await tasksFetcher.deleteTask(taskSelected.id);
              updateTask({
                ...taskSelected,
                deleted_at: new Date().toISOString(),
              });
              sendMessage(
                `La tasca "${taskSelected?.name}" s'ha eliminat correctament`,
                "success"
              );
            } catch (error) {
              sendMessage(
                `Hi ha hagut un error eliminant ${taskSelected?.name}. Si us plau, torna a intentar-ho més tard`,
                "error",
                2.5
              );
            } finally {
              closeModal();
            }
          }}
          type="primary"
        >
          Esborrar
        </Button>
      </footer>
    </ModalContainer>
  );
};

export default DeleteTaskModal;
